import React, { useState, useEffect } from 'react'; 
import './Homepage.css';
import Photoslider from '../../Component/Photoslider/Photoslider';
import Features from '../../Component/Features/Features';
import ChatBot from '../../Component/ChatBot/ChatBot';
import AdCarousel from '../../Component/AdCarousel/AdCarousel'; 
import ProductCarousel from '../../Component/ProductCarousel/ProductCarousel';
import CustomerReview from '../../Component/CustomerReview/CustomerReview';

const Homepage = () => {
  const [shouldShowAd, setShouldShowAd] = useState(false);

  // Check if this is a fresh page load (refresh/reload) and not navigation
  const isPageRefresh = () => {
    // Check for page refresh/reload specifically
    const navigationEntry = window.performance.getEntriesByType('navigation')[0];
    if (navigationEntry) {
      // Only show on 'reload' type, not 'navigate'
      return navigationEntry.type === 'reload';
    }
    
    // Fallback for older browsers
    return window.performance.navigation && window.performance.navigation.type === 1;
  };

  // Determine if ad should be shown based on page refresh
  useEffect(() => {
    if (isPageRefresh()) {
      setShouldShowAd(true);
    }
  }, []);

  return (
    <>
      <div className="homepage">
        <Photoslider/>
        <ProductCarousel />
        <CustomerReview />
        <Features/>
        <ChatBot />
      </div>

      {/* Only render AdCarousel if it's a page refresh */}
      {shouldShowAd && <AdCarousel />}
    </>
  );
}

export default Homepage;